import React, { memo } from "react";
import {
    PAYMENT_OPTIONS_CONSTANTS,
    PAYMENT_OPTIONS_ERROR_CONSTANTS,
    LABEL_CONSTANTS,
} from "./constant";
import { Container, ErrorContainer } from "./styled";
import { BackButton } from "../BackButton";
import { ErrorComponent } from "../ErrorComponent";

interface IPaymentOptionsErrorPageProps {
    onBackClick: VoidFunction;
    handleErrorRetry: VoidFunction;

    title?: string;
    message?: string;
    imgUrl?: string;
    ctaText?: string;
}

const PaymentOptionsErrorPage = ({
    onBackClick,
    handleErrorRetry,
    title,
    message,
    imgUrl,
    ctaText,
}: IPaymentOptionsErrorPageProps) => {
    return (
        <Container>
            <BackButton
                accessibilityLabel={LABEL_CONSTANTS.BACK_BUTTON_ACCESSIBILITY_LABEL}
                hasScrolledBackground={true}
                onClick={onBackClick}
                title={PAYMENT_OPTIONS_CONSTANTS.HEADER_TITLE}
                position="relative"
            />
            <ErrorContainer>
                <ErrorComponent
                    heading={title}
                    description={message}
                    descriptionColor={PAYMENT_OPTIONS_ERROR_CONSTANTS.DESCRIPTION_COLOR}
                    imgSrc={imgUrl}
                    ctaBtnType={PAYMENT_OPTIONS_ERROR_CONSTANTS.CTA_BUTTON_TYPE}
                    imgWidth={PAYMENT_OPTIONS_ERROR_CONSTANTS.IMAGE_WIDTH}
                    showFullPage={PAYMENT_OPTIONS_ERROR_CONSTANTS.SHOW_FULL_PAGE}
                    onCtaClick={handleErrorRetry}
                    ctaText={ctaText}
                    showCta={PAYMENT_OPTIONS_ERROR_CONSTANTS.SHOW_CTA}
                />
            </ErrorContainer>
        </Container>
    );
};

export default memo(PaymentOptionsErrorPage);
